import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import OfferDetails from "../../Components/Offers/OfferDetails";
import "./Styles/Offer.scss";
import { getOfferById } from "../../Api/Offers";
import { OfferType } from "../../types";
import Container from "react-bootstrap/Container";


const Offer = () => {
  console.log("Offer component called");
  const {offerId } = useParams<{offerId: string }>();
  const [offer, setOffer] = useState<OfferType>();

  useEffect(() => {
    console.log("useEffect called");
    const retrieveOffer = async () => {
      try {
        if (offerId) {
          const response = await getOfferById(offerId);
          if (response.code === 200) {
            setOffer(response.data.offer);
          }
        }
      } catch (error) {
        console.error("Error retrieving offer:", error);
      }
    }
    retrieveOffer();
  }, [offerId]);

  return (
    <Container className="container-relative">
      {offer && <OfferDetails {...offer} />}
    </Container>
    
  );
};

export default Offer;
